import UserDataSelect from "./UserDataSelect";

jq(() => {
    const list = new UserDataSelect(
        window.localization,
    );
    list.init();
});
